export const technicianList = "TECHNICIAN_LIST";